import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'gd-product-templates-list-empty-state',
  templateUrl: './product-templates-list-empty-state.component.html',
  styleUrls: ['./product-templates-list-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplatesListEmptyStateComponent {
  @Output() createTemplateButtonClick = new EventEmitter<void>();

  onCreateTemplateButtonClick() {
    this.createTemplateButtonClick.emit();
  }
}
